import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import { setAppLanguage } from '../../actions/app-actions-types';
const LanguageBtn = () => {
  const dispatch = useDispatch();
  let { language = 'en' } = useSelector((state: any) => state.app);
  const onPressChangeLan = () => {
    const lang = language == 'en' ? 'hi' : 'en';
    dispatch(setAppLanguage(lang));
  };
  return (
    <div className="switch">
      <input
        id="language-toggle"
        className="check-toggle check-toggle-round-flat"
        type="checkbox"
        checked={language === 'hi'}
        onChange={onPressChangeLan}
      />
      <label htmlFor="language-toggle"></label>
      <span className="on">EN</span>
      <span className="off">हि</span>
    </div>
  );
};
export default LanguageBtn;
